import axios from 'utils/axios';
import type {
    WarrantyStatisticsType,
    Warranty,
    WarrantyInput,
    WarrantyCreateInput,
    WarrantyListQuery,
    WarrantyListResult,
    WarrantyResult,
    WarrantyHistory,
    WarrantyServiceEntry,
    WarrantyObjectOption,
} from '@econtractor/types';

export const list = async (query: WarrantyListQuery = {}, objectId = 0, eligible = false): Promise<WarrantyListResult> =>
    (
        await axios.get(
            objectId
                ? `/warranties/objects/${objectId}${eligible ? '/eligible' : ''}`
                : '/warranties',
            { params: query },
        )
    ).data;

export const read = async (id: number): Promise<Warranty> =>
    (await axios.get(`/warranties/${id}`)).data;

export const create = async (input: WarrantyCreateInput): Promise<WarrantyResult> =>
    (await axios.post('/warranties/create', input)).data;

export const save = async (id: number, input: WarrantyInput): Promise<WarrantyResult> =>
    (await axios.post(`/warranties/${id}/save`, input)).data;

export const archive = async (id: number, archived: boolean): Promise<WarrantyResult> =>
    (await axios.post(`/warranties/${id}/archive`, { archived })).data;

export const remove = async (id: number): Promise<WarrantyResult> =>
    (await axios.post(`/warranties/${id}/delete`)).data;

export const assign = async (objectId: number, ids: number[], detach = false): Promise<WarrantyResult> =>
    (await axios.post(`/warranties/objects/${objectId}/${detach ? 'detach' : 'attach'}`, { ids }))
        .data;

export const history = async (id: number): Promise<WarrantyHistory[]> =>
    (await axios.get(`/warranties/${id}/history`)).data;

export const service = async (id: number): Promise<WarrantyServiceEntry[]> =>
    (await axios.get(`/warranties/${id}/service`)).data;

export const addService = async (id: number, text: string, serviceDate: string): Promise<WarrantyResult> =>
    (await axios.post(`/warranties/${id}/service`, { text, serviceDate })).data;

export const files = async (id: number, files: string): Promise<WarrantyResult> =>
    (await axios.post(`/warranties/${id}/files`, { files })).data;

export const objectOptions = async (productId: number): Promise<WarrantyObjectOption[]> =>
    (await axios.get(`/warranties/object-options/${productId}`)).data;

export const errorCode = (error: unknown): string =>
    (error as { errCode?: string })?.errCode ||
    (error as { response?: { data?: { errCode?: string } } })?.response?.data?.errCode ||
    'UNKNOWN';

export const getStatistics = async (): Promise<WarrantyStatisticsType> =>
    (await axios.get('/warranties/statistics')).data;
